import { useState } from 'react';

export default function useDownloadPDF() {
  const [loadingExport, setLoadingExport] = useState(false);

  const download = async (reportFetchFunction: () => Promise<{ data: Blob }>, FileName: string) => {
    try {
      setLoadingExport(true);
      if (loadingExport) {
        return;
      }
      const res = await reportFetchFunction(); //this is expected to return de blob
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${FileName}_${new Date().toISOString()}.pdf`);
      document.body.appendChild(link);
      link.click();
      setLoadingExport(false);
    } catch (e) {
      console.log('[WASHDAY-CLIENT-SIDE] [ERROR]:', e);
      throw e;
    }
  };
  return { loadingExport, download };
}
